<template>
  <div class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <label for=""></label>
       <button type="button" class="close" @click="$emit('closeModal')">
                      <span aria-hidden="true">&times;</span>
                    </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-2">Tanggal</div>
          <div class="col-md-10" style="font-weight: bold">
            {{ data.tanggal }}
          </div>
        </div>
        <div class="row mt-2">
            <div class="col-md-2">Ekspedisi</div>
            <div class="col-md-10" style="font-weight: bold">
              {{ data.ekspedisi }}
            </div>
          </div>
          <div
            class="row mt-4"
            style="display: flex; justify-content: space-between"
          >
            <div
              class="col-6"
              style="flex: 1; display: flex; flex-direction: column"
              v-for="(column, columnIndex) in 3"
              :key="columnIndex"
            >
              <div v-for="(plant, plantIndex) in plantOptions.slice(
                                columnIndex * columnSize,
                                (columnIndex + 1) * columnSize
                            )" :key="plantIndex">
                <label class="mt-3 mr-5">Plant {{ plant.plant_code }}</label>
                <span style="font-weight: bold">{{
                  data.details.find((val) => val.plant_name === plant.plant_name)
                    ? data.details.find((val) => val.plant_name === plant.plant_name).qty
                    : 0
                }}</span>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data"],
  data() {
    return {
      plantOptions: [],
      columnSize: 0
    }
  },
  mounted() {
    this.$http.get('/api/master/plant').then(res => {
      this.plantOptions = res.data.data;

      this.columnSize = Math.ceil(res.data.data.length / 3);
    })
  }
};
</script>
<style scoped>
.modal {
  /* Add your modal styles here */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal div {
  /* Add your modal content styles here */
  background-color: white;
  border-radius: 5px;
}

.modal-content {
  background: white;
  width: 650px;
  margin: 100px auto;
  padding: 0 20px 0 20px;
}

.modal-body {
        max-height: 80vh;
        overflow-y: auto;
        overflow-x: auto;
    }

.modal-header {
  border-bottom: none;
}
</style>
